import { getTickerKey, TickerPayload, UpdateHandler } from '@helpers';

export const isTickerInList = (ticker: TickerPayload, list: TickerPayload[]) =>
  list.some(t => getTickerKey(t) === getTickerKey(ticker));

export type WsInitConfig = {
  updateHandler: UpdateHandler;
  delayedPrices: boolean;
};

export interface SubscribeData {
  tickers: TickerPayload[];
  updateHandler: UpdateHandler;
  delayedPrices: boolean;
}
